import { type RootState } from "@ds/store/bootstrap";

const selectBaseState = (state: RootState) => state.notifications;
export const selectToastSettings = (state: RootState) => selectBaseState(state).toastSettings;
